import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import SVG from 'react-inlinesvg';

interface BackButtonProps {
  action?: () => any;
  dispatch?: (action: any) => void;
  url?: string;
  onClick?: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ action, dispatch, url, onClick }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    if (action && dispatch) {
      dispatch(action());
    }

    if (onClick) {
      onClick();
    }

    if (url) {
      navigate(url);
    }
  }, [action, dispatch, onClick, url, navigate]);

  return (
    <div role="button" onClick={handleClick} className="back-button">
      <SVG src={require('assets/media/icons/backward_arrow_icon.svg')} />
      BACK
    </div>
  );
};

export default BackButton;
